import apiClient from 'apiClientRef';
import uiClient from 'uiClientRef'

export default {
    api: {
        orderStateCodes: apiClient.orderStateCodes,
        settings: apiClient.settings,
        netClient: apiClient.netClient,
        loginPrms: apiClient.loginPrms,
        getPostCatLabelsPrms:apiClient.getPostCatLabelsPrms,
        addPostCatLabelPrms:apiClient.addPostCatLabel,
        removePostCatLabelPrms:apiClient.removePostCatLabelPrms,
        getCatConfigLabelsPrms:apiClient.getCatConfigLabelsPrms,
        removeCatConfigLabelPrms:apiClient.removeCatConfigLabelPrms,
        getShopInfoLabelsPrms: apiClient.getShopInfoLabelsPrms,
        getShopInfoLabelByCatIdPrms: apiClient.getShopInfoLabelByCatIdPrms,
        getDashProfilePrms: apiClient.getDashProfilePrms,
        getCategoriesPrms: apiClient.getCategoriesPrms,
        getShopCatLabelsGroupedPrms: apiClient.getShopCatLabelsGroupedPrms,
        getShopListPrms: apiClient.getShopListPrms,
        getUserFilesPrms: apiClient.getUserFilesPrms,
        updateShopCatLabelPrms: apiClient.updateShopCatLabelPrms,
        addShopCatLabelPrms: apiClient.addShopCatLabelPrms,
        updateShopPrms: apiClient.updateShopPrms,
        getshopByUidPrms: apiClient.GetShopByUidPrms,
        getShopViewModelByUidPrms: apiClient.GetShopViewModelByUidPrms,
        removeShopCatLabelPrms: apiClient.removeShopCatLabelPrms,
        uploadFilePrms: apiClient.uploadFilePrms,
        getShopItemsPrms: apiClient.getShopItemsPrms,
        addPostPrms: apiClient.addPostPrms,
        getQAPrms: apiClient.getQAPrms,
        addQAPrms: apiClient.addQAPrms,
        getPerformancePrms: apiClient.getPerformancePrms,
        getCategoryNodePrms:apiClient.getCategoryNodePrms,
        addCategoryPrms:apiClient.AddCategoryPrms,
        updateCategoryPrms:apiClient.updateCategoryPrms,
        updateCategoriesPrms:apiClient.updateCategoriesPrms,
        addCatConfigLabelPrms:apiClient.addCatConfigLabelPrms,
        getAbsUrl: apiClient.getAbsUrl,
        getShopsOrderListPrms:apiClient.GetShopsOrderListPrms,
        getShopOrderDetailPrms:apiClient.GetShopOrderDetailPrms,
        removeOrderExtraPrms:apiClient.removeOrderExtraPrms,
        addOrderExtraPrms:apiClient.addOrderExtraPrms,
        setOrderOfferReadyPrms:apiClient.setOrderOfferReadyPrms,
        updateOrderShopMsgPrms:apiClient.updateOrderShopMsgPrms,
        setOrderStatePrms:apiClient.setOrderStatePrms,
        contactsApiClient:{
            addContactPrms: apiClient.addContactPrms,
            getContactsPrms: apiClient.getContactsPagedPrms,
            getPickupContactsPrms: apiClient.getPickupContactsPrms,
            getPickupContactByIdPrms: apiClient.getPickupContactByIdPrms,
            pickupEnabled: false,
            getCityPrms: function(){
                return apiClient.getCategoryNodePrms(4,null);
            },
            getPhoneDistrictPrms:function(){
                return apiClient.getCategoryNodePrms(5,null);
            },
            getPickupPrms:function(shopUserId){
                return apiClient.getCategoryNodePrms(8,shopUserId);
            }
        }
    },
    ui: {
        getPostClient: uiClient.getPostClient,
        getShopClient: uiClient.getShopClient,
        getShopInfoCatPrms: uiClient.getShopInfoCatPrms
    }
}